import {Outlet} from "react-router-dom";
import {Layout} from "antd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";


export const RootLayout = () => {
  return (
    <Layout style={{ height: "100%" }}>
      <DndProvider backend={HTML5Backend}>
        <Outlet/>
      </DndProvider>
    </Layout>
  )
}